import React from 'react';
import { useTranslation } from 'react-i18next';

import { CircularProgress, Drawer, Grid } from '@material-ui/core';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';

import { ReactComponent as ShowroomFilterIcon } from 'icons/showroomFilterIcon.svg';

import ShowroomFilterTreeContainer, { ComponentProps } from '../FilterTreeContainer/ShowroomFilterTreeContainer';
import { useStyles } from './styles';

export type MobileComponentProps = ComponentProps & {
	onClose: () => void;
	loading: boolean;
	open: boolean;
};

const ShowroomMobileFilters = (props: MobileComponentProps) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const { onClose, loading, open, ...filterProps } = props;

	return (
		<Drawer
			anchor="bottom"
			open={open}
			BackdropProps={{
				style: { background: 'none' }
			}}
			PaperProps={{
				className: classes.modal
			}}
			onClose={onClose}
			ModalProps={{
				keepMounted: true
			}}
			id="showroomMobileFiltersDrawer"
		>
			<Grid>
				<Grid className={classes.title} direction="row" container>
					<ShowroomFilterIcon className={classes.filterIcon} />
					<div>{t('showroom.filter.button.label.mobile')}</div>
					<CancelRoundedIcon id="showroomMobileFiltersCloseIcon" className={classes.closeIcon} onClick={onClose} />
				</Grid>
				{loading ? (
					<div className={classes.loadingContainer} id="showroomMobileFiltersLoading">
						<CircularProgress />
					</div>
				) : (
					<div className={classes.filterContainer} id="showroomMobileFiltersContainer">
						<ShowroomFilterTreeContainer {...filterProps} />
					</div>
				)}
			</Grid>
		</Drawer>
	);
};

export default React.memo(ShowroomMobileFilters);
